import { z } from 'zod';

export const bankAccountResponseSchema = z.object({
  sortCode: z.string(),
  accountNumber: z.string(),
  repaymentDay: z.number().nullable(),
  referenceNumber: z.string(),
});
